<template>
  <div class="component-form">
    <p class="text big bold">Select your HSYLC site preference here. Please do not select any site that you are unable to go.</p>
    <div class="inp-flex mt-30">
      <div class="inp-wrap">
        <Select
          label="First Preference"
          placeholder=""
          :isVerific="false"
          :startVerific="false"
          :value="value.first"
          @input="handleInput($event, 'first')"
          :options="OPTIONS"
        />
      </div>
    </div>
    <div class="inp-flex mt-30">
      <div class="inp-wrap">
        <Select
          label="Second Preference"
          placeholder=""
          :isVerific="false"
          :startVerific="false"
          :value="value.second"
          @input="handleInput($event, 'second')"
          :options="OPTIONS"
        />
      </div>
    </div>
    <div class="inp-flex mt-30">
      <div class="inp-wrap">
        <Select
          label="Third Preference"
          placeholder=""
          :isVerific="false"
          :startVerific="false"
          :value="value.third"
          @input="handleInput($event, 'third')"
          :options="OPTIONS"
        />
      </div>
    </div>
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import { Button } from '../../../../components/form';
import Select from '../../../../components/form/Select/select';
const OPTIONS = [
  {
    label: 'Male',
    value: '1'
  },
  {
    label: 'Female',
    value: '2'
  }
];
export default {
  name: 'SitePreference',
  components: {
    Button,
    Select
  },
  computed: {
    OPTIONS() {
      return OPTIONS;
    }
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    }
  }
};
</script>
